import StudiosToFollow from './StudiosToFollow';

export default StudiosToFollow;
